import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes, { allroutes } from "routes";
import { BackBlockerProvider } from "providers/back-blocker-provider";
import useViewportDimensions, {
  ContentHeightLayout,
  DOCUMENT_PADDING,
  FOOTER_HEIGHT,
  SIDEBAR_WIDTH,
} from "hooks/viewport-dimensions";

export default function Admin(props: { [x: string]: any }) {
  const { ...rest } = props;
  const { isGreaterThanLarge } = useViewportDimensions();
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [mini, setMini] = React.useState(false);
  const [hovered, setHovered] = React.useState(false);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");
  const [activeNavbar, setActiveNavbar] = React.useState<any>(null);

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute([...routes, ...allroutes]);
    // eslint-disable-next-line
  }, [location.pathname]);
  // functions for changing the states from components
  const getActiveRoute = (routes: RoutesType[]): string => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          setCurrentRoute(routes[i].name);
          setActiveNavbar(routes[i].navbar);
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes: RoutesType[]): boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`${prop.path}`} element={prop.component} key={key} />
        );
      }
      if (prop.collapse) {
        return getRoutes(prop.items);
      }
      return null;
    });
  };
  document.documentElement.dir = "ltr";

  return (
    <div className="flex h-full w-full">
      <Sidebar
        open={open}
        hovered={hovered}
        setHovered={setHovered}
        mini={mini}
        onClose={() => setOpen(false)}
      />

      {/* Main Content */}
      <main
        className="absolute bottom-0 top-0 transition-all"
        style={{
          left: `${
            isGreaterThanLarge
              ? SIDEBAR_WIDTH + DOCUMENT_PADDING
              : DOCUMENT_PADDING
          }px`,
          right: `${DOCUMENT_PADDING}px`,
        }}
      >
        {/* Navbar & Main Content */}
        <BackBlockerProvider>
        <div>
          <Navbar
            onOpenSidenav={() => setOpen(!open)}
            brandText={currentRoute}
            secondary={getActiveNavbar(routes)}
            navbarType={activeNavbar}
            theme={props.theme}
            setTheme={props.setTheme}
            hovered={hovered}
            mini={mini}
            setMini={setMini}
            {...rest}
          />

          {/* Routes */}
          <ContentHeightLayout>
            <div className="h-full">
              <Routes>
                {getRoutes(routes)}
                {getRoutes(allroutes)}
                <Route
                  path="/"
                  element={<Navigate to="/admin/dashboards" replace />}
                />
              </Routes>
            </div>
          </ContentHeightLayout>

          <div
            className={`fixed bottom-0 right-0 flex items-baseline justify-center md:items-center`}
            style={{
              height: `${FOOTER_HEIGHT}px`,
              left: `${isGreaterThanLarge ? SIDEBAR_WIDTH : 0}px`,
            }}
          >
            <Footer />
          </div>
        </div>
        </BackBlockerProvider>
      </main>
    </div>
  );
}
